import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _createClass from "babel-runtime/helpers/createClass";
import _possibleConstructorReturn from "babel-runtime/helpers/possibleConstructorReturn";
import _inherits from "babel-runtime/helpers/inherits";
import React, { PureComponent } from 'react';

var GipsyThemeProvider = function (_PureComponent) {
  _inherits(GipsyThemeProvider, _PureComponent);

  function GipsyThemeProvider() {
    _classCallCheck(this, GipsyThemeProvider);

    return _possibleConstructorReturn(this, (GipsyThemeProvider.__proto__ || Object.getPrototypeOf(GipsyThemeProvider)).apply(this, arguments));
  }

  _createClass(GipsyThemeProvider, [{
    key: "render",
    value: function render() {
      return React.createElement(
        "div",
        { className: "gipsy-ui" },
        this.props.children
      );
    }
  }]);

  return GipsyThemeProvider;
}(PureComponent);

export default GipsyThemeProvider;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/GipsyThemeProvider/index.js
// module id = 1135
// module chunks = 0